<section
  class="preview-details-container"
    [ngClass]="{
        'preview-details-container-embedded': embedded,
        'no-border': noBorder
    }"
  >
  <!-- preview details meta data -->
  <div class="preview-details-meta-data">
    <div class="meta-left">
      <!-- Assignment Name -->
      @if (showActivityName) {
        <div class="assignment-name-container">
          <span class="data-label font-size-12px">Assignment Name</span>
          <h2 class="h2-value font-size-18px">
            {{ getDisplayName(asset) }}
          </h2>
          <h3
            class="h3-value font-size-12px"
            [innerHtml]="getAssignableSubTitle(asset)"
          ></h3>
        </div>
      }

      <!-- Description -->
      @if (asset?.assetTypeId !== assetTypeIds.EBOOK_ACT) {
        <div
          class="description-container info-item"
          [ngClass]="{ hasFormatOptions: hasFormatOptions(asset) }"
          >
          <div class="info-item">
            <span class="data-label font-size-12px">Description</span>
            <span
              class="data-value font-size-14px"
              [innerHTML]="getDescription()"
            ></span>
          </div>
          @if (hasFormatOptions(asset)) {
            <div class="info-item">
              <span class="data-label font-size-12px">{{
                optionsHeaderText(asset)
              }}</span>
              <ul class="description-lists data-value font-size-14px">
                @if (hasLaunchLink(asset)) {
                  <li class="pdfLinkHousing">
                    <span class="languageName">{{
                      getLocale(asset)
                    }}</span>
                    <button
                      mat-raised-button
                      class="formatOption"
                      (click)="launchLink(asset)"
                      >
                      {{ getFileType(asset)
                      }}<mat-icon>save_alt</mat-icon>
                    </button>
                    <!--<button mat-raised-button class="formatOption" (click)="launchLink(asset)">{{getLinkText(asset)}}<mat-icon>arrow_forward</mat-icon></button>-->
                  </li>
                }
                @for (linkedExtLink of linkedExtLinks; track linkedExtLink) {
                  <li
                    class="pdfLinkHousing"
                    >
                    <span class="languageName">{{
                      getLocale(linkedExtLink)
                    }}</span>
                    <button
                      mat-raised-button
                      class="formatOption"
                      (click)="launchLink(linkedExtLink)"
                      >
                      {{ getFileType(linkedExtLink)
                      }}<mat-icon>save_alt</mat-icon>
                    </button>
                  </li>
                }
                @if (
                  asset?.assetTypeId &&
                  (asset?.assetTypeId !== assetTypeIds.BUNDLE ||
                  selectedSubTask) &&
                  !hideLaunchButton
                  ) {
                  <span
                    >
                    @for (wsOption of workspaceOptions; track wsOption) {
                      <li
                        class="locale-option-housing"
                        >
                        <mat-icon>language</mat-icon>
                        <span
                          class="locale-option-value data-value font-size-12px"
                          >{{ wsOption }}:</span
                          >
                          <button
                            class="standard-button button-small button-background-teal"
                            (click)="launchWsByLanguage(wsOption)"
                            >
                            Launch {{ wsOption }} version
                          </button>
                        </li>
                      }
                    </span>
                  }
                </ul>
              </div>
            }
          </div>
        }

        <!-- Levels -->
        @if (asset?.levelIds) {
          <div class="info-item">
            <span class="data-label font-size-12px">
              {{ getLevelLabel(asset) }}
            </span>
            <span class="data-value font-size-14px">
              {{ getLevels(asset) }}
            </span>
          </div>
        }

        <!-- Activities -->
        @if (asset?.assetTypeId === assetTypeIds.BUNDLE) {
          <div
            class="info-item"
            >
            <span class="data-label font-size-12px">Activities</span>
            <span class="data-value font-size-14px">
              {{ getActivitiesCount(asset) }}
            </span>
          </div>
        }

        <!-- Book Cover -->
        @if (eBookActivityAsset?.bookImage && !isMath) {
          <img
            class="info-item book-cover"
            [src]="getSpineImage() | async"
            [hidden]="!isSpineImageLoaded"
            (load)="isSpineImageLoaded = true"
            alt="{{ eBookActivityAsset?.bookName || 'book cover' }} image"
            />
        }
      </div>

      <div class="meta-right">
        <!-- Program -->
        <div class="info-item">
          <span class="data-label font-size-12px">Program</span>
          <span class="data-value font-size-14px">
            {{ getProgramName() }}
          </span>
        </div>

        <!-- Pacing -->
        @if (isMath) {
          <div
            class="info-item"
            matTooltip="Average historical time to complete"
            >
            <span class="pacing-row data-label">
              <img
                [src]="pacingIconPath"
                class="pacing-icon"
                alt="Pacing Stopwatch Icon"
                />
              <span class="font-size-12px"> Pacing </span>
            </span>
            <span class="data-value font-size-14px">
              {{ getPacing(asset) }}
            </span>
          </div>
        }

        <!-- Language Options -->

        <!-- Unit -->
        @if (!isMath) {
          <div class="info-item">
            <span class="data-label font-size-12px">Unit</span>
            <span class="data-value font-size-14px">
              {{ getUnit(asset) }}
            </span>
          </div>
        }

        <!-- Lesson -->
        @if (!isMath && !hidePageAndLesson(asset, 'lesson')) {
          <div
            class="info-item"
            >
            <span class="data-label font-size-12px">Lesson</span>
            <span class="data-value font-size-14px">
              {{ getLesson(asset) }}
            </span>
          </div>
        }

        <!-- Page -->
        @if (!isMath && !hidePageAndLesson(asset, 'page')) {
          <div
            class="info-item"
            >
            <span class="data-label font-size-12px">Page</span>
            <span class="data-value font-size-14px">
              {{ getPage(asset) }}
            </span>
          </div>
        }

        <!-- Activity Number -->
        @if (
          asset?.assetTypeId === assetTypeIds.EBOOK_ACT ||
          asset?.assetTypeId === assetTypeIds.EREADER ||
          asset?.assetTypeId === assetTypeIds.CUSTOM_ACT
          ) {
          <div
            class="info-item"
            >
            <span class="data-label font-size-12px">Activity Number</span>
            <span class="data-value font-size-14px">
              {{ getActivityNumber(asset) }}
            </span>
          </div>
        }

        <!-- Activity Type -->
        @if (asset && activityType) {
          <div class="info-item">
            <span class="data-label font-size-12px">Activity Type</span>
            <span class="data-value font-size-14px">
              {{ getDiscoverActivityTypeName(activityType) }}
            </span>
          </div>
        }

        <!-- Response Type -->
        @if (asset?.assetTypeId === assetTypeIds.CUSTOM_ACT) {
          <div
            class="info-item"
            >
            <span class="data-label font-size-12px">Response Type</span>
            <span class="data-value font-size-14px">
              {{ getCustomActivityResponseType(asset) }}
            </span>
          </div>
        }
      </div>
    </div>

    <!-- preview details right -->
    <div class="preview-details-right">
      <!-- Program Logo and Assign -->
      @if (!hideProgramLogo) {
        <div class="program-assign-container">
          <!-- Program Logo -->
          <mat-icon class="program-logo" [svgIcon]="programSVG"></mat-icon>
          <!-- Assign Button -->
          @if (showAssignButton) {
            <div>
              @if (asset?.isAssignable) {
                <button
                  class="standard-button button-small-with-icon button-background-teal"
                    [ngClass]="{
                        'assign-button-disabled':
                            !asset ||
                            (creatingLesson &&
                                asset?.assetTypeId === assetTypeIds.BUNDLE)
                    }"
                  aria-label="Add/Remove to cart"
                  [matTooltip]="getAssignTooltip(assigned)"
                  (click)="handleAssignClick()"
                    [disabled]="
                        !asset ||
                        (creatingLesson &&
                            asset?.assetTypeId === assetTypeIds.BUNDLE)
                    "
                  >
                  Assign
                  @if (!assigned) {
                    <mat-icon class="assign-button-icon"
                      >add_circle</mat-icon
                      >
                    }
                    @if (assigned) {
                      <mat-icon class="assign-button-icon"
                        >remove_circle</mat-icon
                        >
                      }
                    </button>
                  }
                </div>
              }
            </div>
          }

          <!-- Assignment Type and Created By -->
          <div class="type-created-container">
            <!-- Assignment Type -->
            <div class="assignment-type-container">
              <span class="data-label font-size-12px">Assignment Type</span>
              <div class="icon-value-wrapper">
                <img
                  class="type-icon"
                  [src]="getIconPath(asset)"
                  [matTooltip]="getTypeName(asset)"
                  />
                <span
                  class="data-value font-size-12px"
                  [ngClass]="{ type: embedded }"
                  >{{ getTypeName(asset) }}</span
                  >
                </div>
              </div>

              <!-- Created By -->
              <div class="created-by-container">
                <span class="data-label font-size-12px">Created By</span>
                <div class="icon-value-wrapper">
                  @if (isCLLogo()) {
                    <img
                      [src]="clLogoPath"
                      alt="Carnegie Learning Logo"
                      class="created-by-icon"
                      />
                  }
                  @if (!isCLLogo()) {
                    <img
                      [src]="teacherAuthoredPath"
                      class="created-by-icon"
                      alt="Teacher Authored Image"
                      />
                  }
                  <span class="data-value font-size-12px">
                    {{ getAuthor(asset?.visibility, asset?.publishedBy) }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Launch Activity Button -->
            @if (
              asset?.assetTypeId &&
              (asset?.assetTypeId !== assetTypeIds.BUNDLE ||
              selectedSubTask) &&
              !hideLaunchButton &&
              !workspaceOptions.length
              ) {
              <div
                class="launch-activity-container"
                >
                <!-- Launch button -->
                <button
                  class="standard-button button-small button-background-teal"
                  (click)="launchWorkspace()"
                  >
                  Launch the {{ getLaunchTitle() }}
                </button>
              </div>
            }
          </div>
        </section>

        <!-- Preview Activities Container -->
        @if (
          asset?.assetTypeId === assetTypeIds.BUNDLE &&
          !selectedSubTask &&
          !hideSubActivities
          ) {
          <section
            class="preview-activities-container"
            >
            <section-label
              class="section-label"
              [sectionLabelContent]="activitiesSectionLabel"
            ></section-label>
            @for (compositeTaskAssignment of compositeActivities; track compositeTaskAssignment) {
              <mat-expansion-panel
                #expPanel
                [ngClass]="{ 'panel-expanded': expPanel.expanded }"
                class="activities-mat-expansion-panel"
                >
                <mat-expansion-panel-header
                  class="activities-panel-header"
                  collapsedHeight="auto"
                  expandedHeight="auto"
                  >
                  <section class="type-name-container">
                    <!-- Type -->
                    <div class="type-container">
                      <img
                        class="details-icons icon-33-x-33"
                        [src]="getIconPath(compositeTaskAssignment)"
                        alt="Asset Type Icon"
                        />
                      <span class="data-value font-size-12px">{{
                        getTypeName(compositeTaskAssignment)
                      }}</span>
                    </div>
                    <!-- Name -->
                    <div class="activity-name-container">
                      <span class="activity-name">{{
                        compositeTaskAssignment.displayName
                      }}</span>
                    </div>
                  </section>
                  <section class="other-data-container">
                    <!-- Level -->
                    <div>
                      <span class="data-label font-size-12px">{{
                        getLevelLabel(asset)
                      }}</span>
                      <span class="data-value font-size-12px">{{
                        getLevels(compositeTaskAssignment)
                      }}</span>
                    </div>
                    <!-- Pacing -->
                    @if (isMath) {
                      <div>
                        <span class="data-label font-size-12px"
                          >Pacing Estimate</span
                          >
                          <span class="data-value font-size-12px">{{
                            getPacing(compositeTaskAssignment)
                          }}</span>
                        </div>
                      }
                    </section>
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <assignable-preview-details
                      class="assignment-overview-preview-details"
                      [asset]="compositeTaskAssignment"
                      [embedded]="true"
                      [noBorder]="true"
                    ></assignable-preview-details>
                  </ng-template>
                </mat-expansion-panel>
              }
            </section>
          }
